$(() => {
    // stories(index, reviews)
    var swiper_widecards = new Swiper('.swiper-container_reviews', {
        navigation: {
            nextEl: ".swiper-container_reviews .swiper-navigation-next",
            prevEl: ".swiper-container_reviews .swiper-navigation-prev"
        },
        pagination: { el: ".swiper-container_reviews .swiper-pagination", clickable: !0 },
        scrollbar: {
            el: '.swiper-container_reviews .swiper-scrollbar',
            draggable: true,
        },
        updateOnWindowResize: "true",
        breakpoints: {
            2456: {
                slidesPerView: 5,
                spaceBetween: 16,
            },
            1680: {
                slidesPerView: 5,
                spaceBetween: 22,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 15,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            320: {
                spaceBetween: 10,
                slidesPerView: 'auto',
            }
        },
        on: {
            init: function (swiper) {
                //$(swiper.$el[0]).addClass("shown")
            },
        },
    });
});
